import { ChangeEvent } from 'react';

const MAX_MB_SIZE = 5;
const LIMIT_FILE_SIZE = 1024 * 1024 * MAX_MB_SIZE;

export const isFileValid = (event: ChangeEvent<HTMLInputElement>): boolean => {
  const selectedFiles = event.target.files;
  if (selectedFiles && selectedFiles.length > 0) {
    const file = selectedFiles[0];
    if (file.size >= LIMIT_FILE_SIZE) {
      alert(`Файл слишком большой. Максимальный размер файла ${MAX_MB_SIZE}МБ.`);

      return false;
    }
  }

  return true;
};

export const isDroppedFileValid = (file: File): boolean => {
  if (file.size >= LIMIT_FILE_SIZE) {
    alert(`Файл слишком большой. Максимальный размер файла ${MAX_MB_SIZE}МБ.`);
    return false;
  }

  return true;
};
